import { useCallback } from 'react';

export const useFormCustomizeItem = () => {
  const formCustomizeItem = useCallback((e) => {
    if (e.labelText) {
      if (e.label) {
        e.label = { ...e.label, text: e.labelText };
      } else {
        e.label = { text: e.labelText };
      }

      delete e.labelText;
    }
  }, []);

  return formCustomizeItem;
};
